module.exports = __webpack_public_path__ + "static/kodsport-bb0842ec10caf2d3f415090bdb29d71b.png";